module.exports = __webpack_public_path__ + "media/images/tiempo-9ffef91279e8cc337c40f6721d87679c.png";